import React, { Component, PropTypes } from 'react';
import {
  Table,
  TableRow,
  TableHeader,
  TableHeaderColumn,
  TableBody,
  Checkbox,
  MenuItem,
} from 'material-ui';
import ContractRow from './contract-row';

class ContractList extends Component {
  render() {
    const {
      list,
      downloadRates,
      className,
      updateContractStatus,
    } = this.props;

    return (<div className={className} style={{ borderTop: '1px solid rgb(224, 224, 224)' }}>
      <Table bodyStyle={{ overflow: 'visible' }}>
        <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
          <TableRow>
            <TableHeaderColumn colSpan="7" style={{ padding: '0 88px' }}>
              Contract
            </TableHeaderColumn>
            <TableHeaderColumn data-walkthru="contractListStatus" colSpan="2" style={{ padding: 0, textAlign: 'center' }}>
              Status
            </TableHeaderColumn>
            <TableHeaderColumn colSpan="1" style={{ padding: 0, textAlign: 'center' }}>
              Periods
            </TableHeaderColumn>
            <TableHeaderColumn colSpan="1" style={{ padding: 0, textAlign: 'center' }}>
              Modified
            </TableHeaderColumn>
            <TableHeaderColumn colSpan="1" style={{ padding: 0, textAlign: 'center' }}>
              Actions
            </TableHeaderColumn>
          </TableRow>
        </TableHeader>
        <TableBody style={{ overflow: 'visible' }} >
          {
            list.map((contract, i) => (
              <ContractRow
                key={i}
                contract={contract}
                actions={{
                  downloadRates,
                  updateContractStatus,
                }}
              />))
          }
        </TableBody>
      </Table>
      <div style={{ display: (list && list.length) ? 'none' : 'block', minHeight: '100px', fontSize: '24px', textAlign: 'center', marginTop: '50px', marginBottom: '50px' }}>
        There are no files in this category.
      </div>
    </div>);
  }
}

export default ContractList;



// WEBPACK FOOTER //
// ./src/app/components/assets-landing/basic-contract-list/list.jsx